import React, { PureComponent, Fragment } from 'react'
import styles from './Banner.scss'
import { scroller } from 'react-scroll'
export default class Banner extends PureComponent {
  _scrollToPlaceListTop = () => {
    scroller.scrollTo('form', {
      duration: 600,
      delay: 0,
      smooth: 'easeOutCirc',
      isDynamic: true,
    })
  }
  render() {
    return (
      <Fragment>
        <style jsx>{styles}</style>
        <div className="banner">
          <div className="PCBanner">
            <img src="/statics/images/creator/landingPage/PCBanner.png" />
          </div>
          <div className="MOBBanner">
            <img src="/statics/images/creator/landingPage/MOBBanner.png" />
          </div>
          <div className="text">
            <h1>
              波波創作者計畫
              <br />
              Poper
            </h1>
            <h3>獲得名氣、賺取收益</h3>
            <p>波波應援你成為下一個百萬流量創作者</p>
            <div className="BannerBtn Btn" onClick={this._scrollToPlaceListTop}>
              立即展開創作者旅程
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}
